import {
  Widget,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Spinner,
} from "@pf-dev/ui";
import { useAttendance } from "@/hooks";
import type { BaseWidgetProps } from "./types";

const attendanceHeader = [
  { key: "deviceName", label: "구분", className: "w-[60%]" },
  { key: "attendanceCount", label: "출역인원", className: "w-[40%]" },
] as const;

export function Attendance({ id, className }: BaseWidgetProps) {
  const { data, isLoading, isError, error } = useAttendance();

  if (isLoading) {
    return (
      <Widget id={id} className={className} contentClassName="h-full">
        <div className="flex h-full items-center justify-center">
          <div className="flex flex-col items-center gap-4">
            <Spinner size="lg" />
            <p className="text-gray-500">데이터를 불러오는 중...</p>
          </div>
        </div>
      </Widget>
    );
  }

  if (isError) {
    return (
      <Widget id={id} className={className} contentClassName="h-full">
        <div className="flex h-full items-center justify-center">
          <div className="flex flex-col items-center gap-4">
            <div className="text-red-500">
              <svg className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <p className="text-gray-700">
              {error instanceof Error ? error.message : "데이터를 불러오는데 실패했습니다."}
            </p>
          </div>
        </div>
      </Widget>
    );
  }

  return (
    <Widget id={id} className={className} contentClassName="h-full">
      <div className="flex flex-col gap-2 h-full">
        <div className="font-bold text-lg">출역현황</div>

        <div className="flex-1 overflow-hidden">
          <div className="h-full overflow-y-auto [&>div]:!border-0 [&_table]:!border-0 [&_tr]:!border-0 [&_td]:!border-0 [&_th]:!border-r-0">
            <Table>
              <TableHeader>
                <TableRow>
                  {attendanceHeader.map((header) => (
                    <TableHead
                      key={header.key}
                      className={`text-sm bg-[#E7E7E7] text-[#55596C] ${header.className}`}
                    >
                      {header.label}
                    </TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={attendanceHeader.length}
                      className="text-center text-neutral-500 text-sm"
                    >
                      데이터가 없습니다.
                    </TableCell>
                  </TableRow>
                ) : (
                  data.map((attendance) => (
                    <TableRow key={attendance.id} className="text-[#55596C]">
                      <TableCell className="w-[60%] text-[#333] text-sm">
                        {attendance.deviceName}
                      </TableCell>
                      <TableCell className="w-[40%] text-sm">{attendance.attendanceCount}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </Widget>
  );
}
